var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrazil = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_377_6490)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
  fill: "#0D9795"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.50033 2.93555L13.696 7.50076L7.50033 12.066L1.30469 7.50076L7.50033 2.93555Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.50028 10.108C8.94102 10.108 10.109 8.94004 10.109 7.49931C10.109 6.05857 8.94102 4.89062 7.50028 4.89062C6.05955 4.89062 4.8916 6.05857 4.8916 7.49931C4.8916 8.94004 6.05955 10.108 7.50028 10.108Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.19608 7.33594C5.74245 7.33594 5.30467 7.40493 4.89258 7.53296C4.91083 8.95796 6.0711 10.1077 7.50044 10.1077C8.38427 10.1077 9.16485 9.66773 9.63674 8.99534C8.8294 7.98469 7.58719 7.33594 6.19608 7.33594Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0611 7.99911C10.0925 7.83728 10.1094 7.67031 10.1094 7.49931C10.1094 6.05854 8.94149 4.89062 7.50076 4.89062C6.42574 4.89062 5.50289 5.54105 5.10352 6.4697C5.45654 6.39654 5.82205 6.35802 6.19644 6.35802C7.71158 6.35799 9.08227 6.98781 10.0611 7.99911Z",
  fill: "#0052B4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_377_6490"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrazil);
export { ForwardRef as ReactComponent };